import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/components/common/api';
import { PromotionCatalogService } from './../../../../services/promotion/promotion-catalog.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormArray, FormBuilder, FormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ConfirmationService } from 'primeng/components/common/api';
import { AuthService } from 'app/services/user/auth.service';

@Component({
  selector: 'app-catalog-detail',
  templateUrl: './catalog-detail.component.html',
  styleUrls: ['./catalog-detail.component.css']
})
export class CatalogDetailComponent implements OnInit {

  catalogFields: any;
  sndFields: any;
  storeFields: any;
  form: FormGroup;
  invalidSubmit: boolean;
  catalogId: number;
  accumulators: SelectItem[] = [];
  typologies: SelectItem[] = [];
  catalogExclude = '1';
  stores: Array<{data: SelectItem[], show: boolean}> = [];
  storeGroups: Array<{data: SelectItem[], show: boolean}> = [];;
  divisions: any[];
  // salesNetworks: any[];
  timeout: any;
  userId: any;
  headerMsg: string;
  cancelDetailMsg



  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private catalogService: PromotionCatalogService,
    private authService: AuthService,
    private translate: TranslateService,
    public confirmationService: ConfirmationService,
    private router: Router

  ) {
    this.userId = this.authService.user.id.toString();
    this.catalogService.userId = this.userId;
  }

  get f() {
    return this.form.controls;
  }

  get salesNetworkDivisions(): FormArray {
    return this.form.get('salesNetworkDivisions') as FormArray;
  }

  ngOnInit() {

    // Recupero DTO FORM
    this.catalogService.getCatalogFields().subscribe(res => this.catalogFields = res);
    this.catalogService.getSndFields().subscribe(res => this.sndFields = res);
    this.catalogService.getStoreFields().subscribe(res => this.storeFields = res);


    // Popolo Dropdown Tipologie e Flag
    this.translate.get([
      'catalog.store',
      'catalog.storeGroup',
      'catalog.exclude',
      'catalog.headerDeleteGift',
      'catalog.deleteGift'
    ]).subscribe(res => {
      this.typologies = [
        {label: res['catalog.store'], value: '1'},
        {label: res['catalog.storeGroup'], value: '0'}
      ];
      this.catalogExclude = res['catalog.exclude'];
      this.headerMsg = res['catalog.headerDeleteGift'];
      this.cancelDetailMsg = res['catalog.deleteGift'];
    });

    // Verifico che Catalogo esistente e ne recupero l'id
    this.catalogId = this.activatedRoute.snapshot.params['id'];

    if (this.catalogId) {
      this.catalogService.getCatalogData(this.catalogId).subscribe(catalogData => {
        // Se Catalogo Esistente, popolo Form Catalogo
        this.form = this.fb.group({
          code: [catalogData[0]['code']],
          description: [catalogData[0]['description']],
          dt_start: [new Date(catalogData[0]['dt_start'])],
          dt_end: [new Date(catalogData[0]['dt_end'])],
          barcode_cont_pickup: [catalogData[0]['barcode_cont_pickup']],
          barcode_nocont_pickup: [catalogData[0]['barcode_nocont_pickup']],
          salesNetworkDivisions: new FormArray([]),
          long_descr: [catalogData[0]['long_descr']],
          catalog_url: [catalogData[0]['catalog_url']]
        });
        // Recupero Dati Dettagli Validità Divisioni Rete Vendita
        this.catalogService.getSndData(this.catalogId).subscribe(sndData => {
          sndData.forEach((el, i) => {
            this.salesNetworkDivisions.push(this.fb.group({}));
            el.dt_start_reservation = new Date(el.dt_start_reservation);
            el.dt_end_reservation = new Date(el.dt_end_reservation);
            // Popolo dropdown Negozi Divisione
            this.stores.push({data: [], show: false});
            this.storeGroups.push({data: [], show: false});
            this.getDivisionStores(el, i);
            // Per ogni Dettaglio Validità, recupero i dati dei relativi Negozi
            this.catalogService.getStoreData(el.id).subscribe(storeData => {
              el.stores = new FormArray([]);
              if (storeData.length > 0) {
                storeData.forEach(store => {
                  // Popolo i negozi del Dettaglio Validità
                  el.stores.push(this.getStore(store));
                })
              }
              // Popolo il form del Dettaglio Validità
              this.salesNetworkDivisions.controls[i] = this.getSnd(el);
            });
          });
        });
      })
    } else {
      // Se Nuovo Catalogo, creo il form
      this.form = this.fb.group({
        code: [''],
        description: [''],
        dt_start: [''],
        dt_end: [''],
        barcode_cont_pickup: [''],
        barcode_nocont_pickup: [''],
        salesNetworkDivisions: new FormArray([]),
        long_descr: [''],
        catalog_url: ['']
      });
    }

  }

  /**
   * Genera (ed eventualmente popola) i form di Dettagli Validità Divisione Rete Vendita
   */
  getSnd(snd?) {
    return this.fb.group({
      id: [snd ? snd.id : ''],
      name_division: snd ? new FormControl({value: {id: snd.division_sales_network_id, div_sales_name: snd.div_sales_name}, disabled: true}) : [''],
      // name_store: snd ? new FormControl({value: {sales_network_name: snd.name_store}, disabled: true}) : [''],
      dt_start_reservation: [snd ? snd.dt_start_reservation : ''],
      dt_end_reservation: [snd ? snd.dt_end_reservation : ''],
      acm_id: snd ? new FormControl({value: snd.acm_id, disabled: true}) : [''],
      off_promo_code: snd ? new FormControl({value: snd.off_promo_code, disabled: true}) : [''],
      stores: snd ? snd.stores : new FormArray([])
    });
  }

  /**
   * Genera (ed eventualmente popola) i form dei Negozi
   */
  getStore(store?) {
    return this.fb.group({
      id: [store ? store.id : ''],
      type_store: store ? new FormControl({value: store.type_store, disabled: true}) : [null],
      store_id: store ? new FormControl({value: store.store_id, disabled: true}) : [null],
      store_group_id: store ? new FormControl({value: store.store_group_id, disabled: true}) : [null],
      flg_type_excl: new FormControl({value: this.catalogExclude, disabled: true})
    });
  }

  /**
   * Aggiunge un nuovo form di Dettagli Validità Divisione Rete Vendita
   */
  addSalesNetworkDivision() {
    this.stores.push({data: [], show: false});
    this.storeGroups.push({data: [], show: false});
    this.salesNetworkDivisions.push(this.getSnd());
  }

  /**
   * Rimuove un form di Dettagli Validità Divisione Rete Vendita
   */
  removeSalesNetworkDivision(id: number, index: number) {
    this.stores.splice(index, 1);
    this.storeGroups.splice(index, 1);
    if (id) {
      this.catalogService.deleteSnd(id).subscribe(() => this.salesNetworkDivisions.removeAt(index));
    } else {
      this.salesNetworkDivisions.removeAt(index);
    }
  }

  /**
   * Restituisce la lista dei form dei Negozi di un form di Dettagli Validità Divisione Rete Vendita
   */
  getSndStores(sndForm) {
    return (sndForm.get('stores') as FormArray).controls;
  }

  /**
   * Aggiunge un nuovo form di Negozi
   */
  addStore(sndForm: FormGroup) {
    this.getSndStores(sndForm).push(this.getStore());
  }

  /**
   * Rimuove un form di Negozi
   */
  removeStore(id: number, stores, index: number) {
    if (id) {
      this.catalogService.deleteStore(id).subscribe(() => stores.removeAt(index));
    } else {
      stores.removeAt(index);
    }
  }

  save() {
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const catalogData = {
      code: this.f.code.value,
      description: this.f.description.value,
      dt_start: moment(this.f.dt_start.value).format('YYYY-MM-DD'),
      dt_end: moment(this.f.dt_end.value).format('YYYY-MM-DD'),
      barcode_cont_pickup: this.f.barcode_cont_pickup.value,
      barcode_nocont_pickup: this.f.barcode_nocont_pickup.value,
      long_descr: this.f.long_descr.value,
      catalog_url: this.f.catalog_url.value
    }
    if (this.catalogId) {
      // Update Catalogo
      this.catalogService.updateCatalog(this.catalogId, catalogData).subscribe(() => {
        if (this.salesNetworkDivisions && this.salesNetworkDivisions.length > 0) {
          // Update Dettagli Validità Sales Network Division
          this.salesNetworkDivisions.controls.forEach(snd => {
            const sndData = {
              division_sales_network_id: snd.get('name_division').value.id,
              off_promo_code: snd.get('off_promo_code').value,
              dt_start_reservation: moment(snd.get('dt_start_reservation').value).format('YYYY-MM-DD'),
              dt_end_reservation: moment(snd.get('dt_end_reservation').value).format('YYYY-MM-DD'),
              acm_id: snd.get('acm_id').value
            }
            if (snd.get('id').value) {
              this.catalogService.updateSnd(this.catalogId, snd.get('id').value, sndData).subscribe(res => {
                if (this.getSndStores(snd) && this.getSndStores(snd).length > 0) {
                  this.getSndStores(snd).forEach(store => {
                    const storeData = {
                      catalog_div_sal_net_id: res.id,
                      flg_type_excl: '1'
                    };
                    if (store.get('store_id').value) {
                      Object.assign(storeData, {store_id: store.get('store_id').value});
                    } else if (store.get('store_group_id').value) {
                      Object.assign(storeData, {store_group_id: store.get('store_group_id').value})
                    }
                    this.catalogService.excludeStore(storeData).subscribe();
                  })
                }
              });
            } else {
              this.catalogService.addSnd(this.catalogId, sndData).subscribe(res => {
                if (this.getSndStores(snd) && this.getSndStores(snd).length > 0) {
                  this.getSndStores(snd).forEach(store => {
                    const storeData = {
                      catalog_div_sal_net_id: res.id,
                      flg_type_excl: '1'
                    };
                    if (store.get('store_id').value) {
                      Object.assign(storeData, {store_id: store.get('store_id').value});
                    } else if (store.get('store_group_id').value) {
                      Object.assign(storeData, {store_group_id: store.get('store_group_id').value})
                    }
                    this.catalogService.excludeStore(storeData).subscribe();
                  });
                }
              });
            }
          });
        }
        this.router.navigate(['promotion/catalog']);
      });
    } else {
      // Creazione Nuovo Catalogo
      this.catalogService.createCatalog(catalogData).subscribe(res => {
        if (this.salesNetworkDivisions && this.salesNetworkDivisions.length > 0) {
          // Update Dettagli Validità Sales Network Division
          this.salesNetworkDivisions.controls.forEach(snd => {
            const sndData = {
              division_sales_network_id: snd.get('name_division').value.id,
              off_promo_code: snd.get('off_promo_code').value,
              dt_start_reservation: moment(snd.get('dt_start_reservation').value).format('YYYY-MM-DD'),
              dt_end_reservation: moment(snd.get('dt_end_reservation').value).format('YYYY-MM-DD'),
              acm_id: snd.get('acm_id').value
            }
            this.catalogService.addSnd(res.id, sndData).subscribe(sndRes => {
              if (this.getSndStores(snd) && this.getSndStores(snd).length > 0) {
                this.getSndStores(snd).forEach(store => {
                  const storeData = {
                    catalog_div_sal_net_id: sndRes.id,
                    flg_type_excl: '1'
                  };
                  if (store.get('store_id').value) {
                    Object.assign(storeData, {store_id: store.get('store_id').value});
                  } else if (store.get('store_group_id').value) {
                    Object.assign(storeData, {store_group_id: store.get('store_group_id').value})
                  }
                  this.catalogService.excludeStore(storeData).subscribe();
                })
              }
            });
          });
        }
        this.router.navigate(['promotion/catalog']);
      });
    }
  }

  searchDivision(event) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.catalogService.getDivisions(event.query).subscribe(res => {
      this.divisions = res;
    }), 1000);
  }

  /* searchSalesNetwork(event, sndId) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.catalogService.getSalesNetwork(sndId ,event.query).subscribe(res => {
      this.salesNetworks = res;
    }), 1000);
  } */

  getDivisionStores(division: any, index: number, snd?: any) {
    if (snd) {
      snd.get('name_division').setValue({ id: division.division_sales_network_id, div_sales_name: division.div_sales_name });
    }

    this.catalogService.getSndStoresList(division.division_sales_network_id).subscribe(res => {
      res.forEach(r => this.stores[index].data.push({ label: r.name + " - " + r.description, value: r.id }));
      this.stores[index].show = true;
      let channelId= null;
      //prendo il channel_id del primo negozio
      if (res && res.length > 0 && res[0].channel_id) {

        channelId = res[0].channel_id;
      }
        //filtro gli accumulatori in base al channel_id
        this.catalogService.getAccumulators(channelId).subscribe(acms => {
          this.accumulators = [];
          const today = moment().startOf('day');

          acms.forEach(acm => {
            const startDate = moment(acm.dateStart).startOf('day');
            const endDate = moment(acm.dateEnd).startOf('day');
            // Mostro solo accumulatori attivi: oggi > dateStart e oggi < dateEnd
            if (!today.isAfter(startDate) || !today.isBefore(endDate)) {
              return;
            }
            this.accumulators.push({ label: acm.acm_code + ' - ' + acm.acmDescription, value: acm.id });
          });
        });

      
    });


    // Popolo Gruppi di Negozi
    this.catalogService.getStoreGroups(division.division_sales_network_id).subscribe(res => {
      res.forEach(group => this.storeGroups[index].data.push({ label: group.name + " - " + group.description, value: group.id }));
      this.storeGroups[index].show = true;
    });
  }

  confirmCancelValidityDetail(detail, index) {
    this.confirmationService.confirm({
      header: this.headerMsg,
      message: this.cancelDetailMsg,
      acceptLabel: 'OK',
      accept: () => this.removeSalesNetworkDivision(detail, index),
      rejectVisible: true
    });
  }

  confirmCancelStore(detail,getSnd, index) {
    this.confirmationService.confirm({
      header: this.headerMsg,
      message: this.cancelDetailMsg,
      acceptLabel: 'OK',
      accept: () => this.removeStore(detail, getSnd, index),
      rejectVisible: true
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/promotion/catalog/catalog-detail/catalog-detail.component.ts